// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Avatar_avatar__4ylwz","skeleton":"Avatar_skeleton__1J6pU","lightSkeleton":"Avatar_lightSkeleton__1ALgN"};